import React from 'react';
import css from './ViewModeSwitcher.module.css';
import {
    ViewItemTypesModeEnum,
    ViewItemTypesModeType,
} from '@modules/Steps/Shared/Enums/ViewItemTypesModeEnum';
import { notifySuccessCustom } from '@shared/Widgets/ToastNotifications/ToastNotifications';
import BasicSwitcher from '@shared/Ui/Switchers/BasicSwitcher/BasicSwitcher';
import { CustomProjectStep2ElementsIdsEnum } from '@modules/Steps/Shared/Enums/CustomProjectStep2ElementsIdsEnum';
import { FragmentsViewModel } from '@viewModels/FragmentsViewModel/FragmentsViewModel';

interface ViewModeSwitcherProps {
    viewMode: ViewItemTypesModeType;
}

const ViewModeSwitcher: React.FC<ViewModeSwitcherProps> = ({ viewMode }) => {
    const fragmentsViewModel = new FragmentsViewModel();
    const toggleSwitcher = () => {
        const newMode =
            viewMode === ViewItemTypesModeEnum.WorkStage
                ? ViewItemTypesModeEnum.MaterialsLaborTools
                : ViewItemTypesModeEnum.WorkStage;

        fragmentsViewModel.changeFragmentsViewMode(newMode);

        notifySuccessCustom(
            newMode === ViewItemTypesModeEnum.WorkStage
                ? 'Everything in one block'
                : 'Sorting by type. Labours and tools separately'
        );
    };

    const activeIndex = viewMode === ViewItemTypesModeEnum.WorkStage ? 0 : 1;

    return (
        <div
            id={
                CustomProjectStep2ElementsIdsEnum.WORK_AREA_STEP2_SWITCHER_BUTTON
            }
        >
            <BasicSwitcher
                onClick={toggleSwitcher}
                labels={['Work Stage', 'Material|Labour|Tools']}
                activeIndex={activeIndex}
                className={css.switcher}
                labelClassName={css.label}
                activeLabelClassName={css.labelActive}
                markerClassName={css.switcherMarker}
                markerStyle={{
                    left: activeIndex === 0 ? '0' : 'calc(100% - 50%)',
                    transition: 'left 0.3s ease-in-out',
                }}
            />
        </div>
    );
};

export default ViewModeSwitcher;
